import { render, staticRenderFns } from "./AdminCouponTitle.vue?vue&type=template&id=521281c0&"
import script from "./AdminCouponTitle.vue?vue&type=script&lang=ts&"
export * from "./AdminCouponTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports